<div class="flex items-center justify-center gap-0.5 mt-1">
  <app-tender-project-description-button
    [colorClass]="colorClass()"
    [phaseStatusInfo]="phaseStatusInfo()"
    [tenderId]="tenderId()"
  />

  <app-tender-provider-response-button
    [colorClass]="colorClass()"
    [phaseStatusInfo]="phaseStatusInfo()"
    [tenderId]="tenderId()"
  />

  <app-tender-reason-text-button
    [colorClass]="colorClass()"
    [phaseStatusInfo]="phaseStatusInfo()"
  />
</div>
